/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FunctionComponent } from "react";
import { BEM } from "@adapptio/lib-components";
import { Button, IButtonProps } from "./Button/Button";

/**
 * Action Button style
 */
export enum ACTION_BUTTON_STYLE {
	DEFAULT = "default",
	PRIMARY = "primary",
	DANGER = "danger"
}

/**
 * Action button size
 */
export enum ACTION_BUTTON_SIZE {
	DEFAULT = "default",
	LARGE = "large",
	SMALL = "small"
}

/**
 * Action Button props
 */
export interface IActionButtonProps extends IButtonProps {
	style?: ACTION_BUTTON_STYLE;
	size?: ACTION_BUTTON_SIZE;
}

/**
 * Action Button component
 */
export const ActionButton: FunctionComponent<IActionButtonProps> = (props) => {
	const baseClass = BEM("edt-action-button-" + props.size, null, {
		style: props.style
	});

	return <Button {...props} baseClass={baseClass} />;
};

ActionButton.defaultProps = {
	style: ACTION_BUTTON_STYLE.DEFAULT,
	size: ACTION_BUTTON_SIZE.DEFAULT
};
